import { put, call } from "redux-saga/effects";
import { toastr } from "react-redux-toastr";
import Axios from "../../utils/axios";
import {
  submitPlayerPurchaseDone,
  submitPlayerPurchaseError
} from "../../state/purchase/actions";
import { showErrorSnackbar } from "../../utils/util";
import {
  EVENTS,
  PURCHASE,
  SOMETHING_WENT_WRONG_MESSAGE
} from "../../constants";

function* submitPurchase({ params }) {
  const { loadingState } = params;
  try {
    const { history, location, shortName } = params;
    const data = params.payload;
    yield call(() => Axios.core.post("/purchasing/player/purchase", data));
    toastr.clean();
    yield put(submitPlayerPurchaseDone());
    history.push(
      `/${shortName}/${EVENTS}/${data.eventId}/${PURCHASE}${location.search}`
    );
  } catch (e) {
    loadingState.clearState();
    yield put(submitPlayerPurchaseError(e.message));
    showErrorSnackbar(SOMETHING_WENT_WRONG_MESSAGE, {
      removeOnHover: false
    });
  }
}

export default submitPurchase;
